/**
 * @fileOverView
 * @description Single Vyb Page View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var PublicVybsPageTemplate = require('../../templates/pages/publicvybspage.html');
var AmpersandView = require('ampersand-view');
var SubscriptionsView = require('../widgets/subscriptionsview');
var SearchView = require('../components/search');
var app = require('ampersand-app');

var PublicVybsPageView = AmpersandView.extend({

    template : PublicVybsPageTemplate,

    pageName : "PublicVybsPage",

    // Keep the rendered tab title in sync with the server-injected title for
    // /public (pageswitcher sets document.title from this on route change).
    pageTitle : "Browse Public Vybit Subscriptions | Vybit",

    // The marketing header/footer are static markup in the template (see
    // publicvybspage.html) so /public links into the rest of the www site
    // instead of being a dead end. Record the active page name that the
    // in-app HeaderView used to set, for parity with other pages.
    initialize: function() {
        app.currentPageName = this.pageName;
    },

    subviews: {
        subscriptions: {
            selector : '#subscriptions',
            prepareView: function(el) {
                return new SubscriptionsView({
                    el: el,
                    parent: this
                });
            }
        },

        search: {
            selector : 'div.vsearchtable',
            prepareView: function(el) {
                return new SearchView({
                    el: el,
                    parent: this,
                    entity: 'subscriptions'
                });
            }
        }
    }
});

module.exports = PublicVybsPageView;
